var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrustedProfessionals1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1043_4870)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 64,
    height: 64,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5192 47.5477C38.5019 47.7852 38.5168 48.0333 38.5796 48.2792C38.733 48.8719 39.093 49.3547 39.5194 49.5368C39.9156 49.7094 40.3099 49.5945 40.4295 49.4152L41.2561 48.1926C41.4953 47.8402 41.5557 47.2769 41.4152 46.7302C41.0693 45.8167 40.6058 45.487 40.0123 45.3394L38.5192 47.5477ZM37.4135 41.4345L35.9687 43.5701C35.6752 44.0102 35.591 44.6867 35.7549 45.3349C35.9288 46.0198 36.344 46.577 36.8409 46.7851C37.3112 46.9794 37.7831 46.8284 38.0787 46.395L39.4163 44.4175C39.7119 43.9785 39.794 43.3053 39.6302 42.6571C39.4562 41.9689 39.0386 41.4139 38.5442 41.2069C38.1495 41.0332 37.6865 41.0265 37.4135 41.4345ZM34.5493 37.9202L33.2153 39.8943C32.9213 40.3311 32.8392 41.0099 33.0014 41.6603C33.1754 42.343 33.5905 42.9002 34.0874 43.1083C34.5569 43.3053 35.0337 43.1516 35.1823 42.9346L36.6633 40.744C36.9589 40.3039 37.041 39.6274 36.8771 38.9803C36.7024 38.2932 36.2872 37.7382 35.7903 37.5323C35.3333 37.327 34.8275 37.5095 34.5493 37.9202ZM31.9396 34.0286L30.461 36.2203C30.1654 36.6593 30.0833 37.3325 30.2472 37.9774C30.4195 38.6678 30.8371 39.2228 31.334 39.4309C31.8035 39.6241 32.2795 39.4742 32.4264 39.2544L33.909 37.0639V37.0617C34.2046 36.6282 34.2868 35.9539 34.1229 35.3068C33.9513 34.6164 33.5338 34.0614 33.0369 33.8555C32.6572 33.6751 32.1977 33.644 31.9396 34.0286ZM51.1356 20.958C50.1793 21.695 48.85 21.8271 47.5555 21.9553C46.5762 22.0475 45.5659 22.1451 44.8399 22.5148L40.8031 24.5677C40.776 24.5821 40.7478 24.592 40.719 24.5971C40.5241 24.6393 40.3437 24.6753 40.1818 24.7064C39.1989 24.8973 39.0853 24.9556 38.9722 25.3569C38.8691 25.7276 38.9823 26.2621 39.2617 26.7161C39.4896 27.089 40.3815 28.2534 42.2165 27.6545L44.5153 27.2361C45.8027 27.0074 46.8347 28.164 47.659 29.0975L53.8411 35.9139L53.846 35.9106C55.0681 35.2058 56.3413 34.2889 57.4237 32.4919L51.1356 20.958Z",
    fill: "url(#paint0_linear_1043_4870)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6291 20.4762C42.2627 20.5214 41.8427 20.5832 41.4022 20.6445C38.9656 20.9918 37.6147 21.1284 36.9273 20.9585L30.6018 31.9518C30.8243 32.2277 31.0195 32.5402 31.1829 32.8819C31.7116 32.1593 32.5105 31.9012 33.2884 32.2152C34.0519 32.5228 34.6893 33.3491 34.9559 34.3744C35.069 34.8083 35.1045 35.2535 35.0755 35.6798C35.3991 35.6178 35.729 35.6512 36.0419 35.7777C36.8033 36.0831 37.4432 36.9116 37.7077 37.9369C37.8225 38.3686 37.8587 38.8127 37.8313 39.2391C38.1551 39.1768 38.4852 39.2113 38.7977 39.3402C39.5576 39.6477 40.1946 40.4741 40.4611 41.494C40.6287 42.1408 40.6351 42.8064 40.499 43.4032C40.5767 43.4231 40.6564 43.4483 40.7358 43.4817C41.4175 43.7639 41.9965 44.5118 42.2458 45.4339C42.4833 46.3264 42.3803 47.264 41.9901 47.9372L43.1123 49.1356C43.3869 49.4264 43.7872 49.4582 44.1609 49.2162C44.5659 48.9539 44.872 48.421 44.9622 47.8248C44.997 47.5881 44.9911 47.344 44.9449 47.1108L43.5214 45.5903C43.4293 45.49 43.3699 45.3458 43.3558 45.1881C43.3417 45.0305 43.3739 44.8717 43.4457 44.7451C43.481 44.6832 43.5251 44.6313 43.5756 44.5924C43.626 44.5536 43.6818 44.5286 43.7396 44.5189C43.7974 44.5093 43.8561 44.5151 43.9122 44.5361C43.9683 44.5572 44.0207 44.5929 44.0662 44.6414L45.7776 46.4726C45.9475 46.6543 46.4343 46.7027 46.8809 46.4221C47.3504 46.1226 47.7052 45.5054 47.8034 44.8166C47.8976 44.1656 47.7466 43.5344 47.4108 43.1731L45.8629 41.5192C45.7702 41.4199 45.7103 41.276 45.6962 41.1184C45.682 40.9608 45.7147 40.802 45.7872 40.6762C45.8219 40.6137 45.8658 40.5611 45.9161 40.5218C45.9664 40.4825 46.0222 40.4573 46.0801 40.4476C46.1379 40.4379 46.1966 40.444 46.2527 40.4654C46.3087 40.4869 46.3609 40.5233 46.4061 40.5724L48.6563 42.9752C48.9945 43.3344 49.4805 43.3838 49.9295 43.1042C50.395 42.8069 50.7497 42.1908 50.8504 41.4945C50.9446 40.8434 50.7936 40.2144 50.4542 39.8498L48.2033 37.4503C48.1104 37.3497 48.0505 37.2047 48.0364 37.0461C48.0222 36.8875 48.0549 36.7278 48.1275 36.6008C48.1631 36.5393 48.2075 36.4878 48.2582 36.4493C48.3088 36.4109 48.3647 36.3863 48.4225 36.377C48.4803 36.3677 48.539 36.3739 48.595 36.3951C48.651 36.4164 48.7033 36.4523 48.7489 36.5008C48.7489 36.5008 52.1667 40.1499 52.1691 40.1499C52.3391 40.3284 52.8235 40.3789 53.268 40.095C53.7383 39.802 54.0907 39.1859 54.1929 38.4917C54.2856 37.8396 54.1346 37.2062 53.7967 36.8482L47.1072 29.7001C46.3397 28.8598 45.5469 27.9893 44.6259 28.1544L42.3734 28.5469C40.855 29.034 39.4227 28.5522 38.5944 27.2447C38.0951 26.457 37.9251 25.4828 38.1494 24.6994C38.4639 23.6129 39.0663 23.5005 40.0605 23.3134C40.2091 23.2881 40.3689 23.2569 40.5449 23.2198L44.5402 21.252C44.7999 21.123 45.0874 21.0338 45.385 20.9547C44.3578 20.4241 43.6132 20.3923 42.6291 20.4762ZM33.9468 18.3928C33.2192 18.3192 32.5548 19.0514 31.5984 20.7144L29.1526 24.9683C28.268 26.5027 27.9366 27.457 28.0098 28.2657C28.0686 28.9302 28.4149 29.5824 28.7584 29.9501L29.9185 31.1873L36.2182 20.2391L35.4028 19.3676C34.8423 18.7708 34.3833 18.438 33.9468 18.3928ZM54.1478 18.3815C53.7113 18.4181 53.2483 18.7439 52.6833 19.3321L51.8591 20.1859L58.0714 31.2233L58.8744 30.3894C59.569 29.67 59.9233 29.0264 59.9881 28.3624C60.0683 27.556 59.7473 26.5941 58.8768 25.0398L56.4708 20.745C55.5334 19.0649 54.8775 18.3192 54.1478 18.3815Z",
    fill: "url(#paint1_linear_1043_4870)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1043_4870",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1043_4870"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1043_4870"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1043_4870"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1043_4870",
    result: "effect2_dropShadow_1043_4870"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1043_4870",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1043_4870",
    x1: 30.1641,
    y1: 35.29,
    x2: 57.4237,
    y2: 35.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1043_4870",
    x1: 28,
    y1: 33.8779,
    x2: 60,
    y2: 33.8779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedProfessionals1);
export default __webpack_public_path__ + "static/media/Trusted Professionals1.1d122b860dae083f6a0372e9b6f203df.svg";
export { ForwardRef as ReactComponent };